const sections = [
	{
		id: "accessibility", title: "Accessibility", explanation: "From your viewpoint, is your partner accessible to you?",
		questions: [
			"I can get my partner’s attention easily.",
			"My partner is easy to connect with emotionally.",
			"My partner shows me that I come first with him/her.",
			"I am not feeling lonely or shut out in this relationship.",
			"I can share my deepest feelings with my partner. He/she will listen.",
		],
	},
	{
		id: "responsiveness", title: "Responsiveness", explanation: "From your viewpoint, is your partner responsive to you?",
		questions: [
			"If I need connection and comfort, he/she will be there for me.",
			"My partner responds to signals that I need him/her to come close.",
			"I find I can lean on my partner when I am anxious or unsure.",
			"Even when we fight or disagree, I know that I am important to my partner and we will find a way to come together.",
			"If I need reassurance about how important I am to my partner, I can get it.",
		],
	},
	{
		id: "engagement", title: "Engagement", explanation: "Are you positively emotionally engaged with each other?",
		questions: [
			"I feel very comfortable being close to, trusting my partner.",
			"I can confide in my partner about almost anything.",
			"I feel confident, even when we are apart, that we are connected to each other.",
			"I know that my partner cares about my joys, hurts, and fears.",
			"I feel safe enough to take emotional risks with my partner.",
		],
	},
]

export function createAREQuestionnaireConfig() {
	return {
		title: "A.R.E. Questionnaire",
		allowEmptyFields: true,
		fields: [],
		pairedQuestionnaire: {
			responseKind: "choice",
			ratingMax: 5,
			instructions: "Read each statement and answer True or False from your own viewpoint about your partner. Give one point for each True answer.",
			partners: [{id: "partnerA", title: "Partner 1"}, {id: "partnerB", title: "Partner 2"}],
			sections: sections.map(section => ({
				id: section.id, title: section.title, explanation: section.explanation,
				questions: section.questions.map((text, index) => ({id: `${section.id}-${index + 1}`, text})),
			})),
			options: [{id: "true", title: "True", score: 1}, {id: "false", title: "False", score: 0}],
			scoring: {
				method: "sum", threshold: 7,
				atOrAboveText: "You are well on your way to a secure bond and can use Hold Me Tight to enhance that bond.",
				belowText: "This is a time to focus on using the conversations in Hold Me Tight to strengthen the bond with your partner.",
			},
		},
	}
}

export function createAREQuestionnaireDemoPayload() {
	const config = createAREQuestionnaireConfig()
	const answersA = {}
	const answersB = {}
	const countsA = [2, 3, 2]
	const countsB = [4, 1, 3]
	config.pairedQuestionnaire.sections.forEach((section, sectionIndex) => {
		section.questions.forEach((question, index) => {
			answersA[question.id] = index < countsA[sectionIndex] ? "true" : "false"
			answersB[question.id] = index < countsB[sectionIndex] ? "true" : "false"
		})
	})
	return {form: config, reports: {partnerA: {name: "Alex", answers: answersA}, partnerB: {name: "Jordan", answers: answersB}}}
}
